@if (formUpdating) {
  <div class="margin-form-overlay">
    <mat-spinner diameter=32></mat-spinner>
  </div>
}
<form [formGroup]="marginForm" class="margin-form-container">
  <mat-form-field class="mb-1">
    <mat-label i18n>General Expenses</mat-label>
    <input formControlName="generalExpenses" i18n-placeholder matInput placeholder="General Expenses" type="number">
    <span matSuffix>%</span>
    @if (marginForm.hasError('marginSumExceeded') && marginForm.get('generalExpenses').touched) {
      <mat-error>
        General Expenses + Commissions + Profit must be less than 100
      </mat-error>
    }
  </mat-form-field>
  <mat-form-field class="mb-1">
    <mat-label i18n>Commissions</mat-label>
    <input formControlName="commission" i18n-placeholder matInput placeholder="Commissions" type="number">
    <span matSuffix>%</span>
    @if (marginForm.hasError('marginSumExceeded') && marginForm.get('commission').touched) {
      <mat-error>
        General Expenses + Commissions + Profit must be less than 100
      </mat-error>
    }
  </mat-form-field>
  @if (kind === 'USA') {
    <div class="row-start">
      <mat-form-field class="mb-1">
        <mat-label i18n>Capital Improvement Taxes</mat-label>
        <input formControlName="ciTaxesPercentage" i18n-placeholder matInput placeholder="Capital Improvement Taxes"
          type="number">
          <span matSuffix>%</span>
        </mat-form-field>
        <mat-slide-toggle formControlName="capitalImprovement" style="margin-left: 10px">
        </mat-slide-toggle>
      </div>
    }
    <mat-form-field class="mb-1">
      <mat-label i18n>Profit</mat-label>
      <input formControlName="profit" i18n-placeholder matInput placeholder="Profit" type="number">
      <span matSuffix>%</span>
      @if (marginForm.hasError('marginSumExceeded') && marginForm.get('profit').touched) {
        <mat-error>
          General Expenses + Commissions + Profit must be less than 100
        </mat-error>
      }
    </mat-form-field>
    <button (click)="submit()" [disabled]="!marginForm?.valid" mat-button type="button">Save</button>
  </form>
